import { Batch } from "@wingspanhq/wingspan-api-sdk";

import { useQueryFlatfileSkippedRowsCount } from "../query/flatfile/queries";
import { selectorImportBatchRejectedRowsCount } from "../selectors/selectorImportBatchRejectedRowsCount";

/**
 * Number of uploaded spreadsheet rows that did not make it into the batch.
 *
 * Prefers the live Flatfile count, which sees both the rows that failed
 * validation and the rows the Wingspan API refused, and falls back to the
 * `flatfileRejectedRowsCount` batch metadata — which only ever counted the
 * latter — when Flatfile cannot be reached. The metadata is durable, so an old
 * batch whose space is gone keeps reporting what it reports today instead of
 * dropping to nothing.
 */
export function useSkippedRowsCount(batch?: Batch, sheetSlug?: string): number {
  const queryFlatfileSkippedRowsCount = useQueryFlatfileSkippedRowsCount(
    batch,
    sheetSlug
  );

  return (
    queryFlatfileSkippedRowsCount.data ??
    selectorImportBatchRejectedRowsCount(batch)
  );
}
